import styled from 'styled-components';

export const CellContent = styled.div`
  margin: 10px 0;
`;
